// /scover/member-portal/src/components/Landing.js
import React from 'react';
import './Landing.css';

const Landing = ({ navigateTo, logo }) => (
  <section className="landing-page">
    <div className="deal-tile-center">
      <h2>Welcome to Scover's</h2>
      <p className="subtitle">Member Portal</p>
      <img src={logo} alt="Scover Logo" className="welcome-logo" />
      <div className="auth-options">
        <button onClick={() => navigateTo('signup')}>Sign Up</button>
        <button onClick={() => navigateTo('login')}>Login</button>
      </div>
    </div>
  </section>
);

export default Landing;